// extracted by mini-css-extract-plugin
export default {"repejo-container":"Repejo-module__repejo-container--QdHNN","inline-frame-container":"Repejo-module__inline-frame-container--Q4Vfp"};